import { EhrCoachRegistrationStatus } from 'types'

export const REGISTRATION_GATE_PATHS = {
  profile: '/welcome/profile'
} as const

interface IRegistrationGateParams {
  registrationStatus?: EhrCoachRegistrationStatus | null
}

// Only coaches have a coach profile (hence a registrationStatus), so this needs no role
// check — non-coaches have no status and fall through to no redirect. Both pre- and
// post-submit states render the same profile screen, which switches itself to a
// read-only "Submitted · awaiting approval" view when the status is PendingApproval.
export const getRegistrationGateRedirect = ({
  registrationStatus
}: IRegistrationGateParams): string | null => {
  switch (registrationStatus) {
    case EhrCoachRegistrationStatus.PendingRegister:
    case EhrCoachRegistrationStatus.PendingApproval:
      return REGISTRATION_GATE_PATHS.profile
    default:
      return null
  }
}
